/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Member_TitleInputs */

const en_check_in_member_title = /** @type {(inputs: Check_In_Member_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check in daily to earn rewards`)
};

const es_check_in_member_title = /** @type {(inputs: Check_In_Member_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrate cada dia para ganar recompensas`)
};

/**
* | output |
* | --- |
* | "Check in daily to earn rewards" |
*
* @param {Check_In_Member_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_member_title = /** @type {((inputs?: Check_In_Member_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Member_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_member_title(inputs)
	return es_check_in_member_title(inputs)
});